var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTextColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.96222 10.5618C4.9002 10.7184 4.76642 10.8482 4.59002 10.9229C4.41362 10.9976 4.20891 11.0113 4.02049 10.9608C3.83208 10.9104 3.67524 10.7999 3.58416 10.6536C3.49307 10.5072 3.47512 10.3368 3.53422 10.1795L6.79447 1.73074C6.87644 1.51849 7.03715 1.33338 7.25347 1.20207C7.46979 1.07075 7.73055 1 7.99822 1C8.26589 1 8.52666 1.07075 8.74297 1.20207C8.95929 1.33338 9.12 1.51849 9.20197 1.73074L12.4622 10.1795C12.4932 10.2578 12.5053 10.3404 12.4978 10.4226C12.4903 10.5049 12.4634 10.585 12.4185 10.6585C12.3736 10.732 12.3117 10.7973 12.2364 10.8508C12.161 10.9043 12.0737 10.9448 11.9795 10.97C11.8853 10.9953 11.786 11.0047 11.6873 10.9978C11.5887 10.9909 11.4927 10.9678 11.4048 10.9299C11.3169 10.892 11.239 10.8399 11.1754 10.7767C11.1117 10.7136 11.0638 10.6405 11.0342 10.5618L9.99622 7.87177H6.00022L4.96222 10.5618ZM6.48247 6.62232H9.51397L7.99822 2.69406L6.48247 6.62232Z",
    fill: "currentColor"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_42_12091)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 13,
    width: 3,
    height: 2,
    fill: "#D35C48"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 13,
    width: 3,
    height: 2,
    fill: "#E9C54A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 13,
    width: 3,
    height: 2,
    fill: "#68C67B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 13,
    width: 3,
    height: 2,
    fill: "#5596D5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_42_12091"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 13,
    width: 12,
    height: 2,
    rx: 1,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextColor);
export default __webpack_public_path__ + "static/media/textColor.14f4bf063f7983432582d2873c52f9ba.svg";
export { ForwardRef as ReactComponent };